import { render, staticRenderFns } from "./CardapioPedido.vue?vue&type=template&id=240820ff&scoped=true&"
import script from "./CardapioPedido.vue?vue&type=script&lang=js&"
export * from "./CardapioPedido.vue?vue&type=script&lang=js&"
import style0 from "./CardapioPedido.vue?vue&type=style&index=0&id=240820ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240820ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VSpacer})
